import { render, staticRenderFns } from "./CooperativePartner.vue?vue&type=template&id=2e39190d&scoped=true&"
import script from "./CooperativePartner.vue?vue&type=script&lang=js&"
export * from "./CooperativePartner.vue?vue&type=script&lang=js&"
import style0 from "./CooperativePartner.vue?vue&type=style&index=0&id=2e39190d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39190d",
  null
  
)

export default component.exports